import { Stack, Typography } from "@mui/material";
import ContainedButton from "components/Atoms/SharedComponents/Buttons/ContainedButton";
import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  isOpenAssignToEmployee,
  isOpenAssignToFreelancer,
} from "services/modules/modal/Actions";
import { StoreUser } from "services/modules/utils/constant";

export default function AssignDriver({
  route,
  userType,
  displayFreeLancerBtn = true,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <>
      <Stack>
        <Stack alignItems="center" mb="18px">
          <Typography fontSize="20px">
            {t("orders.no_driver_assigned_yet")}
          </Typography>
        </Stack>
        {userType !== StoreUser && (
          <Stack direction="row" gap="24px">
            <ContainedButton
              title={t("orders.assign_employee")}
              onClick={(_) => dispatch(isOpenAssignToEmployee(route))}
            />
            {displayFreeLancerBtn && (
              <ContainedButton
                title={t("orders.assign_freelancer")}
                onClick={(_) => dispatch(isOpenAssignToFreelancer(route))}
              />
            )}{" "}
          </Stack>
        )}
      </Stack>
    </>
  );
}
